//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    import DateTime from 'vue-date-time-m'
    export default{
        name:'basic_nursing',
        components: {
            DateTime
        },
        data(){
            return{
                form:{
                    base_sense:'您好，欢迎入住月子会所，我是你的护士，你入住期间，有任何问题，都可以直接联系我们，你月子期间我们也给你制定了学习的内容，请您确认是否掌握以下月子常识，谢谢你的配合！',
                    feed_raise_posture:'',
                    hiccup_method:'',
                    nursing_guidance:'',
                    preven_mastitis:'',
                    change_diapers:'',
                    wash_ass:'',
                    milk_feed_method:'',
                    baby_sun_method:'',
                    breast_milk_method:'',
                    puerperal_guidance:'',
                    milk_punch_method:'',
                    baby_undress:'',
                    return_milk_guidance:'',
                    baby_after_hair:'',
                    baby_bath:'',
                    meeting_guidance:'',
                    valuable_proposal:'',
                    illness_phenomenon:'',
                    maternal_sign:'',
                    nursing_sign:'',
                },
                maternal_sign_show:false,
                nursing_sign_show:false,
                option:{
                    penColor:"rgb(0, 0, 0)"
                },
                get_host:host.host
            }
        },
        created(){
            // this.get_baby_list()
            if(this.$route.query.list_id){
                this.apiDetail()
            }else{
                // this.apiMemberInfo()
            }
        },
        methods:{
            //请求用户基本信息
            // apiMemberInfo(){
            //     let params = {
            //         token: this.$cookie.get('token'),
            //         maternal_info_id: this.$route.query.id
            //     }
            //     Api.checkRoomApi.memberInfo(params).then ( res => {
            //         console.info(res)
            //         if(res.errcode == 1){
            //             this.form.room_number = res.data.room_name
            //             this.form.maternal_name = res.data.name
            //         }else{
            //             this.$vux.toast.show({
            //                 type: 'cancel',
            //                 text: res.errinfo,
            //             })
            //         }
            //     })
            // },
            // 家属签名操作
            maternal_sign_save(){
                let signature ='maternal_sign_signature'
                let png = this.$refs[signature].save()
                this.form.maternal_sign = encodeURI(png)
                this.maternal_sign_show = true
            },
            maternal_sign_edit(){
                this.maternal_sign_show = false
                this.form.maternal_sign = ''
            },
            maternal_sign_clear(){
                let signature ='maternal_sign_signature'
                let refs = this.$refs[signature].clear()
                this.form.maternal_sign = ''
            },
            // 护士组长签名操作
            nursing_sign_save(){
                let signature ='nursing_sign_signature'
                let png = this.$refs[signature].save()
                this.form.nursing_sign = encodeURI(png)
                this.nursing_sign_show = true
            },
            nursing_sign_edit(){
                this.nursing_sign_show = false
                this.form.nursing_sign = ''
            },
            nursing_sign_clear(){
                let signature ='nursing_sign_signature'
                let refs = this.$refs[signature].clear()
                this.form.nursing_sign = ''
            },
            //请求详情数据
            apiDetail(){
                let params = {
                    token: this.$cookie.get('token'),
                    id:this.$route.query.list_id
                }
                this.$vux.loading.show({
                    text: '正在加载'
                })
                Api.checkRoomApi.confinementSenseDetail(params).then ( res => {
                    console.info(res)
                    if(res.errcode == 200){
                        let data = res.data
                        this.form.base_sense = data.base_sense
                        this.form.feed_raise_posture = data.feed_raise_posture
                        this.form.hiccup_method = data.hiccup_method
                        this.form.nursing_guidance = data.nursing_guidance
                        this.form.preven_mastitis = data.preven_mastitis
                        this.form.change_diapers = data.change_diapers
                        this.form.wash_ass = data.wash_ass
                        this.form.milk_feed_method = data.milk_feed_method
                        this.form.baby_sun_method = data.baby_sun_method
                        this.form.breast_milk_method = data.breast_milk_method
                        this.form.puerperal_guidance = data.puerperal_guidance
                        this.form.milk_punch_method = data.milk_punch_method
                        this.form.baby_undress = data.baby_undress
                        this.form.return_milk_guidance = data.return_milk_guidance
                        this.form.baby_after_hair = data.baby_after_hair
                        this.form.baby_bath = data.baby_bath
                        this.form.meeting_guidance = data.meeting_guidance
                        this.form.valuable_proposal = data.valuable_proposal
                        this.form.illness_phenomenon = data.illness_phenomenon
                        if(data.maternal_sign == ''){
                            this.maternal_sign_show = false
                            this.form.maternal_sign = ''
                        }else{
                            this.maternal_sign_show = true
                            this.form.maternal_sign = data.maternal_sign.indexOf(this.get_host) != -1 ? data.maternal_sign : this.get_host+data.maternal_sign
                        }
                        if(data.nursing_sign == ''){
                            this.nursing_sign_show = false
                            this.form.nursing_sign = ''
                        }else{
                            this.nursing_sign_show = true
                            this.form.nursing_sign = data.nursing_sign.indexOf(this.get_host) != -1 ? data.nursing_sign : this.get_host+data.nursing_sign
                        }
                        this.$vux.loading.hide()
                    }else{
                        this.$vux.loading.hide()
                        this.$vux.toast.show({
                            type: 'cancel',
                            text: res.errinfo,
                        })
                    }
                })
            },
            //请求添加数据
            apiAddForm(){
                let params = {
                    token: this.$cookie.get('token'),
                    member_id:this.$cookie.get('id'),
                    maternal_info_id: this.$route.query.id,
                    base_sense:this.form.base_sense,
                    feed_raise_posture:this.form.feed_raise_posture,
                    hiccup_method:this.form.hiccup_method,
                    nursing_guidance:this.form.nursing_guidance,
                    preven_mastitis:this.form.preven_mastitis,
                    change_diapers:this.form.change_diapers,
                    wash_ass:this.form.wash_ass,
                    milk_feed_method:this.form.milk_feed_method,
                    puerperal_guidance:this.form.puerperal_guidance,
                    milk_punch_method:this.form.milk_punch_method,
                    baby_sun_method:this.form.baby_sun_method,
                    breast_milk_method:this.form.breast_milk_method,
                    baby_undress:this.form.baby_undress, 
                    return_milk_guidance:this.form.return_milk_guidance,
                    baby_after_hair:this.form.baby_after_hair,
                    baby_bath:this.form.baby_bath,
                    meeting_guidance:this.form.meeting_guidance,
                    valuable_proposal:this.form.valuable_proposal, 
                    illness_phenomenon:this.form.illness_phenomenon,
                    maternal_sign:this.form.maternal_sign,
                    nursing_sign:this.form.nursing_sign,
                }
                console.info(params)
                this.$vux.loading.show({
                    text: '正在加载'
                })
                Api.checkRoomApi.addConfinementSense(params).then ( res => {
                    console.info(res)
                    if(res.errcode == 200){
                        this.$vux.loading.hide()
                        this.$router.replace({
                            path:'/success',
                            query:{
                                id:this.$route.query.id,
                                form_id:this.$route.query.form_id,
                                tabVal:this.$route.query.tabVal,
                                name : 'basic_nursing',
                            }
                        })
                    }else{
                        this.$vux.loading.hide()
                        this.$vux.toast.show({
                            type: 'cancel',
                            text: res.errinfo,
                        })
                    }
                })
            },
            // 请求更新数据
            apiUpdateForm(){
                let params = {
                    token: this.$cookie.get('token'),
                    member_id:this.$cookie.get('id'),
                    maternal_info_id: this.$route.query.id,
                    base_sense:this.form.base_sense,
                    feed_raise_posture:this.form.feed_raise_posture,
                    hiccup_method:this.form.hiccup_method,
                    nursing_guidance:this.form.nursing_guidance,
                    preven_mastitis:this.form.preven_mastitis,
                    change_diapers:this.form.change_diapers,
                    wash_ass:this.form.wash_ass,
                    milk_feed_method:this.form.milk_feed_method,
                    puerperal_guidance:this.form.puerperal_guidance,
                    milk_punch_method:this.form.milk_punch_method,
                    baby_sun_method:this.form.baby_sun_method,
                    breast_milk_method:this.form.breast_milk_method,
                    baby_undress:this.form.baby_undress, 
                    return_milk_guidance:this.form.return_milk_guidance,
                    baby_after_hair:this.form.baby_after_hair,
                    baby_bath:this.form.baby_bath,
                    meeting_guidance:this.form.meeting_guidance,
                    valuable_proposal:this.form.valuable_proposal, 
                    illness_phenomenon:this.form.illness_phenomenon,
                    maternal_sign:this.form.maternal_sign.indexOf(this.get_host) != -1 ? this.form.maternal_sign.replace(this.get_host,'') : this.form.maternal_sign,
                    nursing_sign:this.form.nursing_sign.indexOf(this.get_host) != -1 ? this.form.nursing_sign.replace(this.get_host,'') : this.form.nursing_sign,
                    id:this.$route.query.list_id,           
                }
                console.info(params)
                this.$vux.loading.show({
                    text: '正在加载'
                })
                Api.checkRoomApi.updateConfinementSense(params).then ( res => {
                    console.info(res)
                    if(res.errcode == 200){
                        this.$vux.loading.hide()
                        this.$router.replace({
                            path:'/success',
                            query:{
                                id:this.$route.query.id,
                                form_id:this.$route.query.form_id,
                                tabVal:this.$route.query.tabVal,
                                name : 'basic_nursing',
                            }
                        })
                    }else{
                        this.$vux.loading.hide()
                        this.$vux.toast.show({
                            type: 'cancel',
                            text: res.errinfo,
                        })
                    }
                })
            },
            submitForm(){
                if(this.$route.query.list_id){
                    console.info("请求更新数据")
                    this.apiUpdateForm()
                }else{
                    console.info("请求添加数据")
                    this.apiAddForm()
                }
            }
        }
    }



// WEBPACK FOOTER //
// ./src/components/basic_nursing.vue